/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Upload_HintInputs */

const en_landing_studio_upload_hint = /** @type {(inputs: Landing_Studio_Upload_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPG, PNG or WebP · up to 20 MB`)
};

const zh_landing_studio_upload_hint = /** @type {(inputs: Landing_Studio_Upload_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPG、PNG 或 WebP · 最大 20 MB`)
};

/**
* | output |
* | --- |
* | "JPG, PNG or WebP · up to 20 MB" |
*
* @param {Landing_Studio_Upload_HintInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_upload_hint = /** @type {((inputs?: Landing_Studio_Upload_HintInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Upload_HintInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_upload_hint(inputs)
	return zh_landing_studio_upload_hint(inputs)
});
export { landing_studio_upload_hint as "landing.studio.upload_hint" }